import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/shared/store/store';

const selectAITextGenerationState = (state: RootState) => state.aiTextGeneration;

export const selectIsGenerating = createSelector(
  [selectAITextGenerationState],
  (state) => state.isGenerating
);

export const selectIsStreaming = createSelector(
  [selectAITextGenerationState],
  (state) => state.isStreaming
);

export const selectGeneratedText = createSelector(
  [selectAITextGenerationState],
  (state) => state.generatedText
);

export const selectStreamingText = createSelector(
  [selectAITextGenerationState],
  (state) => state.streamingText
);

export const selectTextGenerationError = createSelector(
  [selectAITextGenerationState],
  (state) => state.error
);

export const selectConsentRequired = createSelector(
  [selectAITextGenerationState],
  (state) => state.consentRequired
);

export const selectCurrentRequest = createSelector(
  [selectAITextGenerationState],
  (state) => state.currentRequest
);



